// extracted by mini-css-extract-plugin
export default {"rank":"s_rank__O+CYB","iconWrap":"s_iconWrap__bXPOC"};